export enum POLICY_MEMBER_LIST_RELATION_TYPE {
  SELF = 'S',
  SPOUSE = 'SP',
  DEPENDANT = 'D',
}

export enum POLICY_MEMBER_LIST_GENDER {
  MALE = 'M',
  FEMALE = 'F',
}

export enum POLICY_MEMBER_LIST_MARITAL_STATUS {
  MARRIED = 'M',
  UNMARRIED = 'U',
}

export enum MEMBER_LIST_BULK_FIELDS {
  UNIQUE_ID = 'Unique Id',
  SALUTATION = 'Salutation',
  NAME = 'Name',
  RELATIONSHIP_TO_EMPLOYEE = 'Relationship To Employee',
  DATE_OF_BIRTH = 'Date Of Birth',
  GENDER = 'Gender',
  EFFECTIVE_DATE = 'Effective Date',
  MARITAL_STATUS = 'Marital Status',
  CONTACT_NUMBER = 'Contact Number',
  BANK_NAME = 'Bank Name',
  BRANCH_CODE = 'Branch Code',
  ACCOUNT_NUMBER = 'Account Number',
  REMARKS = 'Remarks',
  SUM_ASSURED = 'Sum Assured',
  DELETION_EFFECTIVE_DATE = 'Deletion Effective Date',
}
